import Api from "./Api";

export default {
  getInvoices(obj) {
    return Api().post("invoice", obj);
  },
  getInvoice(docId) {
    return Api().get("invoice/" + docId);
  },
  sendInvoiceDebtRequest() {
    return Api().get("invoice/sendInvoiceDebtRequest");
  },
  createReturnCustDoc(obj) {
    return Api().post("returncustdoc/createReturnCustDoc", obj);
  },
  getAwaitingReturnCustDocs() {
    return Api().get("returncustdoc/getAwaitingReturnCustDocs");
  },
};
